/**
 * 获取url的pathname
 * @param urlString url
 * @returns pathname
 */
export const getUrlPathname = urlString => {
    const regex = /^https?:\/\/[^\/]+(\/[^?#]*)/;
    const matches = urlString.match(regex);
    const pathname = matches && matches[1] ? matches[1] : 'No pathname found';
    return pathname;
};

/**
 * https://quickapp.lovejade.cn/how-to-parse-a-url-into-hostname-in-javascript/
 * 获取url的hostname，替换urijs，包体积太大了
 * @param urlString
 * @returns hostname
 */
export function getUrlHostname(urlString) {
    if (!urlString) {
        return '';
    }

    const reg = /^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i;
    const res = urlString.match(reg);
    return res?.[1];
}
